import { ICellRendererParams } from "ag-grid-community";
import { useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import classNames from "classnames";

type CellDecorator = {
    decorator: JSX.Element;
    position: "start" | "end";
    containerClassName?: string;
    showOnHover?: boolean;
}
export interface IBaseCellRendererParams<T> extends ICellRendererParams<T> {
    align?: "left" | "right" | "center";
    decorators?: CellDecorator[];
    loading?: boolean;
    children?: React.ReactNode;


    decorator?: JSX.Element;
    decoratorPosition?: "start" | "end";
}

export default function BaseCellRenderer<T>({align, decorator, decoratorPosition, decorators, loading, children, ...params}: IBaseCellRendererParams<T>) {
    // console.log(props.colDef);
    // const isUp = typeof props.value === "number" && props.value > 0;
    // const bgCol = typeof props.value === "number" && props.value < 0 ? "red" : "green";
    // const fontCol = typeof props.value === "number" && props.value < 0 ? "black" : "white";
    const [hoveringCell, setHoveringCell] = useState<boolean>(false);

    const startDecorators = useMemo<CellDecorator[] | undefined>(() => decorators?.filter(d => d.position === "start"), [decorators]);
    const endDecorators = useMemo<CellDecorator[] | undefined>(() => decorators?.filter(d => d.position === "end"), [decorators]);
    return (
        <>
        {loading ? <Spinner variant="primary" size="sm"></Spinner> : 
            <div onMouseEnter={() => setHoveringCell(true)} onMouseLeave={() => setHoveringCell(false)} className={`${align === "right" ? "justify-content-end" : (align === "center" ? "justify-content-center" : "")} w-100 h-100 d-inline-flex align-items-center ps-1 pe-1`}>
                {decorator && decoratorPosition === "start" && decorator}
                {startDecorators?.map((d, i) => <div key={i} className={classNames("me-1", d.showOnHover === true ? hoveringCell ? "visible" : "invisible" : {}, d.containerClassName)}>{d.decorator}</div>)}
                {children ? children : params.valueFormatted ?? params.value}
                {endDecorators?.map((d, i) => <div key={i} className={classNames("me-1", d.showOnHover === true ? hoveringCell ? "visible" : "invisible" : {}, d.containerClassName)}>{d.decorator}</div>)}
                {decorator && decoratorPosition === "end" && decorator}
                {/*<TooltipIcon
                    icon={isUp ? "mdi mdi-arrow-up-thin" : "mdi mdi-arrow-down-thin"}
                    text={"Test"}
                    colour={'#'+(0x1000000+Math.random()*0xffffff).toString(16).substr(1,6)}
                    placement={"top"}
                />
                {props.colDef?.headerName ==="Jul 23" ?
                <TooltipIcon
                    icon={"mdi mdi-information"}
                    classes={["p-0", "m-0"]}
                    text={"Test"}
                    colour={'#'+(0x1000000+Math.random()*0xffffff).toString(16).substr(1,6)}
                    placement={"top"}
                /> : <></>} */}
            </div>
        }
        </>
    );
}